export const AGENT_ROLE_LABELS = {
    agent: 'Agent',
    admin: 'Admin',
    time_admin: 'Time admin',
    billing_admin: 'Billing admin',
    quote_agent: 'Quote agent',
};
/**
 * Who may write, price and send a quote, and read the send history.
 *
 * Quoting is not technician work: what a client is being charged while a
 * deal is still open is not team-readable. Defined here rather than in
 * each package so the server's gate and the UI that hides the controls
 * cannot drift apart - the same reason RUNAWAY_TIMER_MINUTES lives in
 * shared.
 *
 * Note what this does NOT gate: the SOW itself. A technician has to know
 * what was promised, so the scope sections stay readable by every agent
 * and only the money is withheld.
 */
export function canWriteQuotes(role) {
    return role === 'admin' || role === 'quote_agent';
}
/** Whether this role may see unit prices, line amounts and totals. */
export const canSeeQuotePricing = canWriteQuotes;
/**
 * Money that has already been sold: contracts, charging a card, invoices.
 * `billing_admin` is the job; `admin` has everything. Shared so the
 * server's gate and the UI that hides the button cannot disagree.
 */
export function canManageBilling(role) {
    return role === 'admin' || role === 'billing_admin';
}
//# sourceMappingURL=auth.js.map